import {
  EVENT_ADD_NEW_ROOM,
  EVENT_DELETE_ROOM,
  EVENT_SET_ROOM_FIELD,
  EventAddNewRoomPayload,
  EventDeleteRoomPayload,
  EventSetRoomFieldPayload,
} from '@weblite/ts-action/room'

import { setReceived } from '$logic/room-seen'
import { serverSub } from '$func/subscription'
import { updateRoomLastMessage } from '$logic/room-last-message'
import { roomsStorage } from '$logic/room/storage'
import { callService, callStorage } from '$logic/call'
import { openPvCallManager } from '$logic/router'
import { getClientUserId } from '$logic/client-user'
import { getMessageByIid, isMessageFromClientUser } from '$logic/message'
import { setUserStatusTemporaryOnline } from '$logic/users'
import { getPv } from '$logic/pv'
import { TWA_EVENTS, twaCommunication } from '$logic/twaCommunication'
import * as roomService from './service'
import { getRoomFromRedux } from './service'

serverSub.subscribe(
  EVENT_SET_ROOM_FIELD,
  async (payload: EventSetRoomFieldPayload) => {
    await roomsStorage.set(payload.roomId, payload.roomUpdate)

    const { iid, call, seenIid } = payload.roomUpdate
    const clientUserId = getClientUserId()

    const { type: callType, callerId, startedAt, name: callName } = call || {}

    if (payload.roomId === callStorage.get().roomId) {
      if (startedAt) callStorage.set({ startedAt })
      if (callName) await callService.sendNewNameToWapp(callName)
    }

    if (callType === 'call' && clientUserId !== callerId && !startedAt) {
      callStorage.reset()
      callStorage.set({
        callType: 'call',
        roomId: payload.roomId,
        state: 'incoming',
        isCaller: callerId === clientUserId,
      })

      openPvCallManager()
      twaCommunication.showCallNotification(
        payload.roomId,
        TWA_EVENTS.SHOW_INCOMING_CALL_NOTIFICATION,
      )
    }

    if (iid) {
      await setReceived([{ roomId: payload.roomId, receivedIid: iid }])
      await updateRoomLastMessage(payload.roomId)
    }

    if (seenIid && getRoomFromRedux(payload.roomId).type === 'PV') {
      const seenMessage = await getMessageByIid(payload.roomId, seenIid)
      // NOTE: If the message originated from the client user, the patch that is being viewed is coming from another user.
      if (isMessageFromClientUser(seenMessage)) {
        const pv = await getPv(payload.roomId)
        setUserStatusTemporaryOnline(pv.to)
      }
    }
  },
)

serverSub.subscribe(
  EVENT_ADD_NEW_ROOM,
  (payload: EventAddNewRoomPayload) => roomService.addRoom(payload), // TODO: need to check lastMessage
)

serverSub.subscribe(EVENT_DELETE_ROOM, (payload: EventDeleteRoomPayload) =>
  roomService.pruneRoom(payload.roomId),
)
